import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import { isEmpty } from 'lodash'
import Pagination from 'pages/Pagination'
import { useEffect, useState } from 'react'
import CountUp from 'react-countup'
import { useTranslation } from 'react-i18next'
import { BsArrowUpShort } from 'react-icons/bs'
import helper from 'utils/helpers'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import OInputField from 'components/reusable/OInputField'
const Subscription = ({ companyId, config }) => {
  const [agent, setAgent] = useState([])
  const [page, setPage] = useState(1)
  const [totalEarning, setTotalEarning] = useState()
  const [pageSize] = useState(10)

  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    isReset: false,
    filterType: '',
    searchKey: '',
    year: '',
    month: ''
  })

  const { startDate, endDate, searchKey, year, month, filterType } = filterData

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end
    })
  }

  const handleChange = event => {
    if (event.target.value === 'company_wise') {
      setFilterData({
        ...filterData,
        year: '',
        month: '',
        [event.target.name]: event.target.value
      })
    } else if (event.target.value === 'month_wise') {
      setFilterData({
        ...filterData,
        searchKey: '',
        [event.target.name]: event.target.value
      })
    } else {
      setFilterData({
        ...filterData,
        [event.target.name]: event.target.value
      })
    }

    setPage(1)
  }

  const handleChangeData = e => {
    // setKeyword(e.target.value)
    setFilterData({ ...filterData, searchKey: e.target.value })
    setPage(1)
  }
  const handleReset = () => {
    setFilterData({
      startDate: '',
      endDate: '',
      isReset: true,
      filterType: '',
      year: '',
      month: ''
    })
    setPage(1)
  }
  const { t } = useTranslation()

  const allAgent = async () => {
    try {
      const payload = {
        page,
        pageSize: pageSize,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        companyId
      }
      if (filterType) payload.filterType = filterType
      if (searchKey) payload.keyword = searchKey
      if (year) payload.year = year
      if (month) payload.month = month
      const path = apiPath.getReportsSubscription
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      setTotalEarning(response?.totalEarning)
      const resultStatus = result?.data?.success
      setAgent(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  useEffect(() => {
    allAgent()
  }, [page, filterData, sort])

  const YearArray = [2023, 2022, 2021, 2020]
  const MonthArray = [
    { key: 'Jan', value: 1 },
    { key: 'Feb', value: 2 },
    { key: 'Mar', value: 3 },
    { key: 'Apr', value: 4 },
    { key: 'May', value: 5 },
    { key: 'Jun', value: 6 },
    { key: 'Jul', value: 7 },
    { key: 'Aug', value: 8 },
    { key: 'Sep', value: 9 },
    { key: 'Oct', value: 10 },
    { key: 'Nov', value: 11 },
    { key: 'Dec', value: 12 }
  ]
  return (
    <>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='flex justify-between w-full'>
                <div className='col-span-2 flex flex-wrap  items-center'>
                  <div className='flex items-center lg:pt-0 pt-3 flex-wrap'>
                    <ODateRangePicker
                      handleDateChange={handleDateChange}
                      isReset={filterData?.isReset}
                      setIsReset={setFilterData}
                    />
                    <div className='flex items-center  ml-3 mb-3'>
                      <select
                        id='filterType'
                        name='filterType'
                        className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                        placeholder=' '
                        value={filterType}
                        onChange={handleChange}
                      >
                        <option selected value=''>
                          {t('O_ALL')}
                        </option>
                        <option value='company_wise'>
                          {t('O_COMPANY_WISE')}
                        </option>
                        <option value='month_wise'>{t('O_MONTH_WISE')}</option>
                      </select>
                    </div>
                    <button
                      type='button'
                      onClick={handleReset}
                      className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                    >
                      {t('O_RESET')}
                    </button>
                    <div className='flex items-center ml-3 w-72'>
                      {filterType === 'month_wise' && (
                        <>
                          <div className='flex items-center  ml-3 mb-3'>
                            <select
                              name='year'
                              className='block p-2 text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                              placeholder=' '
                              value={year}
                              onChange={handleChange}
                            >
                              <option value=''>{t('O_SELECT_YEAR')}</option>
                              {YearArray.map(key => (
                                <option key={key} value={key}>
                                  {key}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className='flex items-center  ml-3 mb-3'>
                            <select
                              name='month'
                              className='block p-2 text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                              placeholder=' '
                              value={month}
                              onChange={handleChange}
                            >
                              <option value=''>{t('O_SELECT_MONTH')}</option>
                              {MonthArray.map(({ key, value }) => (
                                <option key={key} value={value}>
                                  {key}
                                </option>
                              ))}
                            </select>
                          </div>
                        </>
                      )}
                      {filterType === 'company_wise' && (
                        <OInputField
                          value={filterData?.searchKey}
                          type='text'
                          placeholder={t('O_SEARCH_BY_COMPANY_NAME')}
                          onChange={e => handleChangeData(e)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-span-2 flex flex-wrap items-center flex-none'>
                <div className='text-sm mb-3 sm:w-auto w-1/2'>
                  Total Earnings
                </div>
                <div className='text-green-700 bg-green-200 text-sm px-1 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent hover:bg-[#8FC150] sm:w-auto w-1/2 inline-block text-center'>
                  <CountUp duration={0.6} end={totalEarning} />{' '}
                  {config?.currency}
                </div>
              </div>
            </form>
            <div className='p-3'>
              <div className='overflow-x-auto relative 
 border'>
                <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                  <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                    <tr>
                      <th scope='col' className='py-3 px-6'>
                        #
                      </th>
                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          if (
                            sort.sortKey === 'name' &&
                            sort.sortType === 'asc'
                          ) {
                            setSort({
                              sortKey: 'name',
                              sortType: 'desc'
                            })
                          } else {
                            setSort({
                              sortKey: 'name',
                              sortType: 'asc'
                            })
                          }
                        }}
                      >
                        <div className='flex'>
                          <span>{t('O_COMPANY_NAME')} </span>
                          <span>
                            {sort.sortKey === 'name' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'name' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>

                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          if (
                            sort.sortKey === 'email' &&
                            sort.sortType === 'asc'
                          ) {
                            setSort({
                              sortKey: 'email',
                              sortType: 'desc'
                            })
                          } else {
                            setSort({
                              sortKey: 'email',
                              sortType: 'asc'
                            })
                          }
                        }}
                      >
                        <div className='flex'>
                          <span>{t('Subscription Name')} </span>
                          <span>
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>
                      <th
                        scope='col'
                        className='py-3 px-6 cursor-pointer'
                        onClick={() => {
                          if (
                            sort.sortKey === 'email' &&
                            sort.sortType === 'asc'
                          ) {
                            setSort({
                              sortKey: 'email',
                              sortType: 'desc'
                            })
                          } else {
                            setSort({
                              sortKey: 'email',
                              sortType: 'asc'
                            })
                          }
                        }}
                      >
                        <div className='flex'>
                          <span>{t('O_PLAN_CHARGES')} </span>
                          <span>
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'asc' && (
                                <BsArrowUpShort className='w-4 h-4' />
                              )}
                            {sort.sortKey === 'email' &&
                              sort.sortType === 'desc' && (
                                <BsArrowUpShort className='w-4 h-4 rotate-180' />
                              )}
                          </span>
                        </div>
                      </th>

                      <th scope='col' className='py-3 px-6 '>
                        {t('O_TYPE')}
                      </th>

                      <th scope='col' className='py-3 px-6 '>
                        {t('O_EARNING_DATE')}
                      </th>
                      <th scope='col' className='py-3 px-6 '>
                        {t('O_EARNING')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {agent &&
                      agent.length > 0 &&
                      agent?.map((item, i) => (
                        <tr
                          key={i}
                          className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                        >
                          <th
                            scope='row'
                            className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                          >
                            {i + 1 + 10 * (paginationObj?.page - 1)}
                          </th>
                          <td className='py-2 px-2 border-r'>
                            {item?.company?.name}{' '}
                          </td>
                          <td className='py-2 px-2 border-r'>
                            {item?.subscription?.name}
                          </td>
                          <td className='py-2 px-2 border-r'>
                            <span className='text-yellow-700 bg-yellow-200 rounded-md p-2 inline-block text-center'>
                              {helper.priceFormat(item?.earnings) +
                                ' ' +
                                config?.currency}
                            </span>
                          </td>
                          <td className='py-2 px-2 border-r '>
                            {item?.subscriptionTenure === 1 && 'Monthly'}
                            {item?.subscriptionTenure === 3 && 'Quarterly'}
                            {item?.subscriptionTenure === 6
                              ? 'Half Yearly'
                              : 'Yearly'}
                          </td>
                          <td className='py-2 px-2 border-r '>
                            {helper.dateFormat(item?.createdAt)}
                          </td>
                          <td className='py-2 px-2 border-r '>
                            <span className='text-green-700 bg-green-200 rounded-md p-2 inline-block text-center'>
                              {helper.priceFormat(item?.earnings) +
                                ' ' +
                                config?.currency}
                            </span>
                          </td>
                        </tr>
                      ))}
                    {isEmpty(agent) && (
                      <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                        <td className='py-4 px-6' colSpan={12}>
                          {t('O_NO_RECORD_FOUND')}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Subscription
